webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(20);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(16);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Icon = __webpack_require__(15);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_Icon2.default.inject('chameleon'); // The Vue build version to load with the `import` command
	// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
	
	_Icon2.default.inject('settings');
	_Icon2.default.inject('unlock');
	_Icon2.default.inject('sun');
	_Icon2.default.inject('cup');
	_Icon2.default.inject('pie');
	_Icon2.default.inject('settings2');
	_Icon2.default.inject('roboAd');
	
	_vue2.default.component('icon', _Icon2.default);
	
	/* eslint-disable no-new */
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 5 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./chameleon.svg": 7,
		"./cup.svg": 8,
		"./pie.svg": 9,
		"./roboAd.svg": 10,
		"./settings.svg": 11,
		"./settings2.svg": 12,
		"./sun.svg": 13,
		"./unlock.svg": 14
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 6;


/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports = {"svg":{"$":{"version":"1.1","id":"图层_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 200 200","enable-background":"new 0 0 200 200","xml:space":"preserve"},"path":[{"$":{"fill":"#007348","d":"M123.7,116.9c-3.7,0-7-2.4-8.1-6.1L109.7,90c-1.2-4.1,1-8.5,5-10.1l18.6-7.5c4.3-1.7,9.2,0.4,10.9,4.7\n\tc1.7,4.3-0.4,9.2-4.7,10.9l-11.6,4.7l3.8,13.5c1.3,4.5-1.3,9.1-5.8,10.4C125.2,116.8,124.4,116.9,123.7,116.9L123.7,116.9z\n\t M69.4,116.9c-3.7,0-7-2.4-8.1-6.1L55.5,90c-1.2-4.1,1-8.5,5-10.1l18.6-7.5c4.3-1.7,9.2,0.4,10.9,4.7c1.7,4.3-0.4,9.2-4.7,10.9\n\tl-11.6,4.7l3.8,13.5c1.3,4.5-1.3,9.1-5.8,10.4C71,116.8,70.2,116.9,69.4,116.9L69.4,116.9z"}},{"$":{"fill":"#65513C","d":"M200,102.9H0V124h142.9l19,19c0.7,0.7,1.7,1.1,2.7,1.1c2.1,0,3.8-1.7,3.8-3.8c0-1-0.4-2-1.1-2.7L153.8,124\n\tH200V102.9z"}},{"$":{"fill":"#00945E","d":"M161.6,131.8c-5.7,5.7-5.7,14.9,0,20.5c5.7,5.7,14.9,5.7,20.5,0L161.6,131.8z"}},{"$":{"d":"M168.9,34.8c-8.5-10.4-20.9-17.4-34.9-19h0c-0.2,0-0.5-0.1-0.7-0.1c-2.9,0-5.3,2.4-5.3,5.3v16.3c-8.6-4.2-18.3-6.5-28.5-6.5\n\tH81.5c-36.4,0-65.9,29.5-65.9,65.9v44.6c0,23.7,19.3,43,43,43c19.9,0,36-16.2,36-36c0-16.8-13.7-30.4-30.4-30.4\n\tc-14.3,0-26,11.6-26,26c0,12.3,10,22.4,22.4,22.4c4.4,0,8-3.6,8-8c0-4.4-3.6-8-8-8c-3.5,0-6.3-2.8-6.3-6.3c0-5.4,4.4-9.9,9.9-9.9\n\tc7.9,0,14.3,6.4,14.3,14.3c0,11-8.9,19.9-19.9,19.9c-14.9,0-26.9-12.1-26.9-26.9V96.7h135.1c17.1,0,31-13.9,31-31\n\tC197.8,49.3,185.1,35.8,168.9,34.8L168.9,34.8z"}},{"$":{"fill":"#00945E","d":"M111.6,116.9c-3.7,0-7-2.4-8.1-6.1L97.7,90c-1.2-4.1,1-8.5,5-10.1l18.6-7.5c4.3-1.7,9.2,0.4,10.9,4.7\n\tc1.7,4.3-0.4,9.2-4.7,10.9l-11.6,4.7l3.8,13.5c1.3,4.5-1.3,9.1-5.8,10.4C113.1,116.8,112.4,116.9,111.6,116.9L111.6,116.9z\n\t M57.4,116.9c-3.7,0-7-2.4-8.1-6.1L43.4,90c-1.2-4.1,1-8.5,5-10.1L67,72.5c4.3-1.7,9.2,0.4,10.9,4.7s-0.4,9.2-4.7,10.9l-11.6,4.7\n\tl3.8,13.5c1.3,4.5-1.3,9.1-5.8,10.4C58.9,116.8,58.1,116.9,57.4,116.9L57.4,116.9z"}},{"$":{"fill":"#00945E","d":"M151.3,56.4c0,5.3,4.3,9.5,9.5,9.5s9.5-4.3,9.5-9.5s-4.3-9.5-9.5-9.5S151.3,51.1,151.3,56.4z"}},{"$":{"fill":"#333E48","d":"M155,53.8c0,1.5,1.2,2.8,2.8,2.8s2.8-1.2,2.8-2.8c0,0,0,0,0,0c0-1.5-1.2-2.8-2.8-2.8\n\tC156.3,51,155,52.3,155,53.8C155,53.8,155,53.8,155,53.8z"}},{"$":{"fill":"#28B07F","d":"M62.7,48.4c0,0.9,0.7,1.5,1.5,1.5c0.9,0,1.5-0.7,1.5-1.5l0,0c0-0.9-0.7-1.5-1.5-1.5\n\tC63.4,46.9,62.7,47.5,62.7,48.4z"}},{"$":{"fill":"#28B07F","d":"M66.8,37.4c0,0.9,0.7,1.5,1.5,1.5c0.9,0,1.5-0.7,1.5-1.5c0,0,0,0,0,0c0-0.9-0.7-1.5-1.5-1.5\n\tC67.4,35.8,66.8,36.5,66.8,37.4C66.8,37.4,66.8,37.4,66.8,37.4z"}},{"$":{"fill":"#28B07F","d":"M45.7,49.9c0,0.9,0.7,1.5,1.5,1.5c0.9,0,1.5-0.7,1.5-1.5c0,0,0,0,0,0c0-0.9-0.7-1.5-1.5-1.5\n\tS45.7,49.1,45.7,49.9C45.7,49.9,45.7,49.9,45.7,49.9z"}},{"$":{"fill":"#28B07F","d":"M55.6,43.5c0-0.9-0.7-1.6-1.5-1.6s-1.6,0.7-1.6,1.5c0,0,0,0,0,0.1c0,0.9,0.7,1.5,1.6,1.5\n\tC54.9,45,55.6,44.3,55.6,43.5z"}},{"$":{"fill":"#28B07F","d":"M75.5,40.4c0,0.9,0.7,1.5,1.5,1.5c0.9,0,1.5-0.7,1.5-1.5c0-0.9-0.7-1.5-1.5-1.5\n\tC76.1,38.9,75.5,39.6,75.5,40.4z"}},{"$":{"fill":"#28B07F","d":"M112.9,37.4c0,0.9,0.7,1.5,1.5,1.5c0.9,0,1.5-0.7,1.5-1.5c0,0,0,0,0,0c0-0.9-0.7-1.5-1.5-1.5\n\tC113.6,35.8,112.9,36.5,112.9,37.4C112.9,37.4,112.9,37.4,112.9,37.4z"}},{"$":{"fill":"#28B07F","d":"M109.4,48.4c0,0.9,0.7,1.5,1.5,1.5c0.9,0,1.5-0.7,1.5-1.5c0,0,0,0,0,0c0-0.9-0.7-1.5-1.5-1.5\n\tC110.1,46.9,109.4,47.5,109.4,48.4C109.4,48.4,109.4,48.4,109.4,48.4z"}},{"$":{"fill":"#28B07F","d":"M80.1,46.9c0,0.9,0.7,1.5,1.5,1.5c0.9,0,1.5-0.7,1.5-1.5c0-0.9-0.7-1.5-1.5-1.5C80.8,45.3,80.1,46,80.1,46.9\n\tz"}},{"$":{"fill":"#28B07F","d":"M88.9,36.7c0,0.9,0.7,1.5,1.5,1.5c0.9,0,1.5-0.7,1.5-1.5l0,0c0-0.9-0.7-1.5-1.5-1.5\n\tC89.6,35.1,88.9,35.8,88.9,36.7z"}},{"$":{"fill":"#28B07F","d":"M104.3,38.9c0-0.9-0.7-1.5-1.5-1.5c-0.9,0-1.5,0.7-1.5,1.5c0,0,0,0,0,0c0,0.9,0.7,1.5,1.5,1.5\n\tC103.6,40.4,104.3,39.7,104.3,38.9z"}},{"$":{"fill":"#28B07F","d":"M95.8,46.9c0,0.9,0.7,1.5,1.5,1.5c0.9,0,1.5-0.7,1.5-1.5c0-0.9-0.7-1.5-1.5-1.5C96.5,45.3,95.8,46,95.8,46.9\n\tz"}}]}}

/***/ },
/* 8 */
/***/ function(module, exports) {

	module.exports = {"svg":{"$":{"version":"1.1","id":"图层_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 200 200","enable-background":"new 0 0 200 200","xml:space":"preserve"},"path":[{"$":{"d":"M41.5,13.4V92v0.7v0.1c0.1,9.1,2.3,17.8,6.5,25.9l0.2,0.3c10,18.6,30.2,30.7,51.9,30.7s41.9-12.1,52-30.7l0.1-0.3\n\tc4.1-7.7,6.4-16.5,6.6-25.3v-0.6V13.4H41.5z M109.1,87.1l4.4,13.5l-11.4-8.4c-1-0.8-2.4-0.8-3.4,0l-11.4,8.3L91.7,87\n\tc0.4-1.2-0.1-2.6-1.1-3.3l-11.3-8.2h14.1c1.3,0,2.5-0.9,2.8-2.2l4.3-13.3l4.3,13.4c0.4,1.2,1.5,2,2.7,2l0,0h14.1l-11.4,8.3\n\tC109.1,84.6,108.8,86,109.1,87.1z"}},{"$":{"fill":"#111111","d":"M192.9,37.2L192.9,37.2H172V8.8c0-4.3-3.4-7.7-7.8-7.7h-128c-4.3,0-7.7,3.4-7.7,7.7v28.4H7.7\n\tc-4.2,0-7.7,3.4-7.7,7.7v42.6c0,12.2,4.9,23.4,13,31.6l0,0c7.1,7.1,16.5,11.9,27,13c11.6,18,31.1,30.3,52.6,32.7v19.3H59.1\n\tc-4.2,0-7.7,3.4-7.7,7.7c0,4.2,3.5,7.7,7.7,7.7h82.6c4.2,0,7.8-3.6,7.8-7.7c0-4.3-3.6-7.7-7.8-7.7h-33.5v-19.3\n\tc21.5-2.3,41-14.7,52.6-32.7c10.2-1.2,19.5-5.8,26.5-12.7l0.4-0.4c8.1-8.1,13-19.3,13-31.6V44.8C200.7,40.6,197.2,37.2,192.9,37.2\n\tL192.9,37.2z M24,108.2L24,108.2c-5.4-5.5-8.6-12.6-8.6-20.7V52.6h13.1v42c0.2,6.5,1.2,12.9,3,19.2C28.7,112.4,26.2,110.4,24,108.2\n\tL24,108.2z M158.7,92.8v0.6c-0.2,8.8-2.5,17.6-6.6,25.3L152,119c-10.2,18.6-30.2,30.7-51.9,30.7S58.3,137.6,48.3,119l-0.2-0.3\n\tc-4.2-8-6.4-16.7-6.5-25.9v-0.1V92V13.3h117.2L158.7,92.8L158.7,92.8z M185.2,87.5L185.2,87.5c0,8.1-3.3,15.2-8.5,20.7l-0.3,0.3\n\tc-2.2,2.1-4.6,3.9-7.2,5.3c1.9-6.3,2.8-12.6,3-19.2v-0.4V52.6h13.1v34.9H185.2z M109.5,69.9L103.1,50c-0.3-0.8-0.9-1.6-1.8-1.9\n\tc-1.5-0.5-3.2,0.4-3.7,1.9l-6.4,19.9H70.3c-0.9,0-1.8,0.4-2.3,1.2c-1,1.2-0.7,3,0.6,4l17,12.3L79,107.2c-0.3,0.9-0.2,1.8,0.4,2.6\n\tc0.9,1.2,2.8,1.6,4,0.6l16.9-12.3l16.8,12.2c0.7,0.6,1.8,0.8,2.7,0.5c1.5-0.5,2.4-2.1,1.8-3.6l-6.5-19.9L132,75.1\n\tc0.8-0.5,1.3-1.4,1.3-2.4c0-1.6-1.3-2.9-2.9-2.9L109.5,69.9z M110.1,83.9L110.1,83.9c-1,0.8-1.4,2.1-1,3.2l4.4,13.5L102,92.2\n\tc-1-0.8-2.4-0.8-3.4,0l0,0l-11.4,8.3L91.6,87c0.4-1.2-0.1-2.6-1.1-3.3l-11.3-8.2h14.1c1.3,0,2.5-0.9,2.8-2.2l4.3-13.3l4.3,13.4\n\tc0.4,1.2,1.5,2,2.7,2l0,0h14.1L110.1,83.9L110.1,83.9z"}}]}}

/***/ },
/* 9 */
/***/ function(module, exports) {

	module.exports = {"svg":{"$":{"version":"1.1","id":"图层_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 200 200","enable-background":"new 0 0 200 200","xml:space":"preserve"},"path":[{"$":{"fill":"#111111","d":"M120.9,47.7c-4,0-7.5,3.4-7.5,7.5s3.4,7.5,7.5,7.5c4,0,7.5-3.2,7.5-7.5C128.4,51.1,124.9,47.7,120.9,47.7z\n\t M120.9,23.2c-4,0-7.5,3.2-7.5,7.5c0,4,3.4,7.5,7.5,7.5c4,0,7.5-3.4,7.5-7.5S124.9,23.2,120.9,23.2z M120.9,72.3\n\tc-2,0-3.8,0.8-5.3,2.2s-2.2,3.2-2.2,5.3c0,2,0.8,3.8,2.2,5.3s3.2,2.2,5.3,2.2c2,0,3.8-0.8,5.3-2.2s2.2-3.2,2.2-5.3\n\tc0-2-0.8-3.8-2.2-5.3C124.7,73.1,122.7,72.3,120.9,72.3z M177.5,79.8c0-4-3.4-7.5-7.5-7.5c-4,0-7.5,3.4-7.5,7.5c0,4,3.2,7.5,7.5,7.5\n\tC174.2,87.3,177.5,83.9,177.5,79.8z M152.8,79.8c0-4-3.2-7.5-7.5-7.5c-4,0-7.5,3.4-7.5,7.5c0,4,3.4,7.5,7.5,7.5\n\tC149.6,87.3,152.8,83.9,152.8,79.8z"}},{"$":{"d":"M168.8,110H90.4V31.6C47.2,31.6,12,66.8,12,110s35.1,78.3,78.3,78.3S168.8,153.3,168.8,110z"}},{"$":{"fill":"#111111","d":"M90.4,31.6V110h78.3c0,43.3-35.2,78.3-78.4,78.3S12,153.3,12,110S47.2,31.6,90.4,31.6 M168.8,110L168.8,110\n\t M90.4,20c-49.7,0-90,40.4-90,90c0,49.6,40.4,90,90,90c49.6,0,89.9-40.2,90-89.7c0-0.1,0-0.2,0-0.3c0-6.4-5.2-11.6-11.6-11.6h0\n\th-66.7V31.6C102.1,25.2,96.9,20,90.4,20L90.4,20z"}},{"$":{"fill":"#111111","d":"M194.1,87.3c-3.3,0-6-2.7-6-6c0-37.7-30.7-68.5-68.5-68.5c-3.3,0-6-2.7-6-6s2.7-6,6-6\n\tc44.4,0,80.5,36.1,80.5,80.5C200.1,84.6,197.4,87.3,194.1,87.3z"}}],"text":[{"_":"fill=\"#111111\"","$":{"transform":"matrix(1 0 0 1 306 396)","font-family":"'AdobeSongStd-Light-GBpc-EUC-H'","font-size":"12px"}}]}}

/***/ },
/* 10 */
/***/ function(module, exports) {

	module.exports = {"svg":{"$":{"version":"1.1","id":"图层_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 200 200","enable-background":"new 0 0 200 200","xml:space":"preserve"},"path":[{"$":{"fill":"#010101","d":"M163,132c-11.1,0-21.2,5.3-27.5,14l-62-14.3c-0.8-10-6-19-14.1-24.7l9.1-48.9c3.6-1.7,6.8-4.1,9.3-7.2\n\tl10.3-0.6c-3.2,3.8-5,8.6-5,13.9c0,3.6,0.9,7.1,2.5,10.2l-2,6.3c-7.5,3.5-12.7,11.1-12.7,19.8c0,12,9.8,21.8,21.8,21.8\n\tc5.4,0,10.5-2,14.4-5.4l14,0.2c5.2,7,13.5,11.3,22.4,11.3c15.4,0,27.9-12.5,27.9-27.9c0-7.1-2.7-13.7-7.3-18.8l6.3-27.7\n\tc10.6-4.1,18-14.2,18-26c0-15.4-12.5-27.9-27.9-27.9c-10.9,0-20.5,6.4-25.1,15.7l-54.8,3.2c-4.9-8.4-14.1-14-24.2-14\n\tC41,5.1,28.5,17.6,28.5,33c0,7.8,3.2,15.1,8.8,20.3L28,102.7c-13.2,4.8-22.4,17.4-22.4,31.9c0,18.7,15.2,34,34,34\n\tc7.6,0,15-2.6,21-7.4l70.5,16.3c4.8,13.2,17.5,22.5,31.9,22.5c18.7,0,34-15.2,34-34C196.9,147.3,181.7,132,163,132z M162.9,190.2\n\tc-12.2,0-22.3-9.2-23.9-20.9l-81.3-18.8c-4.4,5-10.9,8.3-18.1,8.3c-13.4,0-24.2-10.8-24.2-24.2c0-12.2,9.3-22.4,21.1-23.9L48,49.1\n\tc-5.9-3.1-9.7-9.2-9.7-16.1c0-10,8.1-18.1,18.1-18.1c8.8,0,16.1,6.3,17.8,14.4l68.4-4c1.3-8.7,8.8-15.3,17.8-15.3\n\tc9.9,0,18.1,8.1,18.1,18.1c0,9.3-7.1,17.1-16.4,18l-9,39.2c5,3.3,8.4,9,8.4,15.3c0,9.9-8.1,18.1-18.1,18.1c-7.5,0-14-4.6-16.8-11.2\n\tl-23.9-0.4c-2.1,3.3-5.9,5.5-10.1,5.5c-6.6,0-12-5.4-12-12c0-6.2,4.7-11.3,10.7-11.9l4.9-15.8c-2.1-2.2-3.5-5.2-3.5-8.6\n\tc0-6.6,5.4-12,12-12c6.6,0,12,5.4,12,12c0,5.6-4,10.3-9.1,11.7l-5.5,17.5c0.2,0.3,0.4,0.6,0.6,0.9l23.5,0.1\n\tc2.3-6.4,8.1-11.1,15-11.9l9.1-39.4c-2.3-1.5-4.2-3.6-5.7-6l-72.5,4.2c-2.4,4.8-7,8.2-12.4,9.3L48.5,112c9,3.7,15.3,12.3,15.3,22.5\n\tc0,1.6-0.2,3.3-0.5,4.8l77.1,17.8c3.6-9.1,12.3-15.4,22.5-15.4c13.4,0,24.1,10.8,24.1,24.2C187.1,179.4,176.3,190.2,162.9,190.2z\n\t M119.9,48.4l19.6-1.1l-6.3,27.3c-5.1,2-9.5,5.5-12.6,10l-5.2,0l0.5-1.5c6.6-3.9,10.8-11,10.8-18.8C126.7,58,124.1,52.4,119.9,48.4z\n\t"}},{"$":{"d":"M163,141.8c-10.2,0-19,6.4-22.5,15.4l-77.1-17.8c0.3-1.5,0.5-3.2,0.5-4.8c0-10.2-6.4-18.9-15.3-22.5L60,50.6\n\tc5.4-1.1,10-4.4,12.4-9.3l72.5-4.2c1.4,2.4,3.4,4.4,5.7,6l-9.1,39.4c-6.9,0.8-12.7,5.5-15,11.9L103,94.3c-0.2-0.3-0.4-0.6-0.6-0.9\n\tl5.5-17.5c5.1-1.3,9.1-6.1,9.1-11.7c0-6.6-5.4-12-12-12c-6.6,0-12,5.4-12,12c0,3.4,1.3,6.4,3.5,8.6l-4.9,15.8\n\tc-6,0.7-10.7,5.8-10.7,11.9c0,6.6,5.4,12,12,12c4.2,0,8-2.2,10.1-5.5l23.9,0.4c2.8,6.6,9.3,11.2,16.8,11.2c10,0,18.1-8.2,18.1-18.1\n\tc0-6.4-3.4-12-8.4-15.3l9-39.2c9.3-1,16.4-8.7,16.4-18c0-10-8.2-18.1-18.1-18.1c-9.1,0-16.6,6.6-17.8,15.3l-68.4,4\n\tc-1.7-8.1-9.1-14.4-17.8-14.4c-10,0-18.1,8.1-18.1,18.1c0,6.9,3.9,13,9.7,16.1l-11.6,61.6c-11.9,1.5-21.1,11.7-21.1,23.9\n\tc0,13.4,10.8,24.2,24.2,24.2c7.2,0,13.7-3.3,18.1-8.3l81.3,18.8c1.6,11.8,11.7,20.9,23.9,20.9c13.4,0,24.2-10.8,24.2-24.2\n\tS176.4,141.8,163,141.8z"}}]}}

/***/ },
/* 11 */
/***/ function(module, exports) {

	module.exports = {"svg":{"$":{"version":"1.1","id":"图层_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 200 200","enable-background":"new 0 0 200 200","xml:space":"preserve"},"path":[{"$":{"d":"M155.3,110.4l-7.1-4.1c-1.5-0.9-2.3-2.5-2.3-4.2c0.1-2.5,0-4.9-0.2-7.3c-0.2-1.7,0.5-3.3,2-4.3l7-4.7\n\tc1.7-1.1,2.3-3.4,1.5-5.2l-2.3-5l-2.3-5c-0.9-1.8-2.9-2.8-4.9-2.3l-7.9,2.2c-1.7,0.5-3.4-0.1-4.6-1.4c-1.6-1.8-3.4-3.5-5.3-5\n\tc-1.3-1.1-2-2.7-1.7-4.4l1.6-8.3c0.4-2-0.8-4.1-2.7-4.7l-5.2-1.9l-5.2-1.9c-2-0.7-4.1,0-5.2,1.8l-4.1,7c-0.9,1.5-2.5,2.3-4.3,2.3\n\tc-2.6-0.2-5.1-0.1-7.6,0.2c-1.7,0.2-3.4-0.5-4.3-1.9l-4.7-6.9c-1.1-1.7-3.4-2.3-5.2-1.5l-5,2.3l-5,2.3c-1.8,0.9-2.8,2.9-2.3,4.9\n\tl2.1,8c0.5,1.6-0.1,3.4-1.4,4.5c-1.8,1.6-3.5,3.4-5,5.4c-1.1,1.4-2.7,2-4.4,1.7l-8.1-1.6c-2-0.4-4,0.7-4.8,2.6l-1.9,5.2l-1.9,5.2\n\tc-0.7,2,0,4.1,1.8,5.2l7.2,4.1c1.5,0.9,2.3,2.5,2.3,4.2c-0.1,2.5,0,5,0.2,7.4c0.2,1.7-0.5,3.4-1.9,4.3l-6.8,4.6\n\tc-1.7,1.1-2.3,3.4-1.5,5.2l2.3,5l2.3,5c0.9,1.8,2.9,2.8,4.9,2.3l8-2.1c1.6-0.5,3.4,0.1,4.5,1.4c1.6,1.8,3.4,3.5,5.4,5\n\tc1.4,1.1,2,2.7,1.7,4.4l-1.6,8.1c-0.4,2,0.8,4.1,2.7,4.7l5.2,1.9l5.2,1.9c2,0.7,4.1,0,5.2-1.8l4.1-7.2c0.9-1.5,2.5-2.3,4.2-2.3\n\tc2.3,0.1,4.7,0,7-0.2c1.7-0.2,3.4,0.5,4.3,2l4.7,7c1.1,1.7,3.4,2.3,5.2,1.5l5-2.3l5-2.3c1.8-0.9,2.8-2.9,2.3-4.9l-2.1-7.9\n\tc-0.5-1.7,0.1-3.4,1.4-4.6c1.8-1.6,3.5-3.4,5-5.3c1.1-1.3,2.7-2,4.4-1.7l8.3,1.6c2,0.4,4.1-0.8,4.7-2.7l1.9-5.2l1.9-5.2\n\tC157.9,113.6,157,111.4,155.3,110.4L155.3,110.4z M118.9,106.6c-3.7,10.4-15.1,15.9-25.6,12.2c-10.4-3.7-15.9-15.1-12.2-25.6\n\tc3.7-10.4,15.1-15.9,25.6-12.2C117.1,84.7,122.5,96.2,118.9,106.6z"}},{"$":{"fill":"#000001","d":"M98.8,0.1c-26.7,0.3-51.7,11-70.3,30.1C15.1,43.9,6,60.9,2.1,79.6c-3.8,18.1-2.5,36.9,3.8,54.3\n\tc0.5,1.5,2,2.5,3.5,2.5c0.4,0,0.9-0.1,1.3-0.2c1.9-0.7,2.9-2.8,2.3-4.7c-12.1-33.6-4.1-70.4,20.9-96C51.1,17.7,74.2,7.8,98.9,7.5\n\tc24.7-0.3,48,9.1,65.7,26.4l0.6,0.5L154,34.5c-2,0-3.7,1.7-3.7,3.8c0,2,1.7,3.7,3.7,3.7h0l20.1-0.2c2,0,3.7-1.7,3.7-3.8l-0.2-20.1\n\tc0-2-1.7-3.7-3.7-3.7h0c-2,0-3.7,1.7-3.7,3.8l0.1,11.2l-0.6-0.5C150.7,9.9,125.5-0.2,98.8,0.1z M22,162.1l0.2,20.1\n\tc0,2,1.7,3.7,3.7,3.7h0c2,0,3.7-1.7,3.7-3.8L29.6,171l0.6,0.5c19.4,19,44.6,28.4,69.9,28.4c26,0,51.9-10,71.5-30\n\tc13.4-13.7,22.5-30.7,26.4-49.4c3.8-18.1,2.5-36.9-3.8-54.3c-0.7-1.9-2.8-2.9-4.7-2.3c-1.9,0.7-2.9,2.8-2.3,4.7\n\tc12.1,33.6,4.1,70.4-20.9,96c-35.6,36.5-94.4,37.2-130.8,1.5l-0.6-0.5l11.2-0.1c2,0,3.7-1.7,3.7-3.8c0-2-1.7-3.7-3.7-3.7h0\n\tl-20.1,0.2C23.6,158.4,22,160.1,22,162.1L22,162.1z"}},{"$":{"fill":"#000001","d":"M61.1,69.1c-0.2,0.2-0.5,0.4-0.8,0.3l-8.1-1.6c-0.5-0.1-0.9-0.1-1.4-0.1c-3.2,0-6.1,1.9-7.4,4.9\n\tc0,0,0,0.1-0.1,0.2L39.4,83c-1.4,3.6,0.1,7.7,3.5,9.7l7.2,4.1c0.2,0.2,0.4,0.5,0.4,0.8c-0.1,2.7,0,5.4,0.3,8c0,0.3-0.1,0.7-0.3,0.8\n\tl-6.9,4.7c-3.2,2.2-4.3,6.3-2.7,9.8l4.5,9.9c1.3,2.8,4.1,4.6,7.2,4.6c0.7,0,1.4-0.1,2-0.3l8-2.1c0.3-0.1,0.6,0,0.8,0.3\n\tc1.8,2,3.8,3.8,5.9,5.4c0.2,0.2,0.4,0.5,0.3,0.8l-1.6,8.1c-0.7,3.8,1.4,7.6,5,8.9l10.3,3.8c0.9,0.3,1.8,0.5,2.8,0.5\n\tc2.8,0,5.4-1.5,6.9-4l4.1-7.2c0.2-0.2,0.5-0.4,0.8-0.4c2.5,0.1,5.1,0,7.6-0.2c0.3,0,0.7,0.1,0.8,0.3l4.7,7c1.5,2.2,3.9,3.5,6.5,3.5\n\tc1.1,0,2.3-0.2,3.3-0.7l9.9-4.5c3.5-1.6,5.4-5.5,4.3-9.2l-2.1-7.9c-0.1-0.3,0-0.6,0.3-0.9c2-1.8,3.8-3.7,5.4-5.8\n\tc0.2-0.2,0.5-0.4,0.8-0.3l8.3,1.6c0.5,0.1,1,0.1,1.5,0.1c3.3,0,6.3-2.1,7.4-5.2l3.8-10.3c1.4-3.6-0.1-7.7-3.5-9.7l-7.1-4.1\n\tc-0.2-0.2-0.4-0.5-0.4-0.8c0.1-2.6,0-5.3-0.2-7.9c0-0.3,0.1-0.6,0.3-0.8l7-4.7c3.2-2.2,4.3-6.3,2.7-9.8l-4.5-9.9\n\tc-1.3-2.8-4.1-4.6-7.2-4.6c-0.7,0-1.4,0.1-2.1,0.3l-7.9,2.2c-0.3,0.1-0.6,0-0.9-0.3c-1.8-2-3.7-3.8-5.7-5.4\n\tc-0.3-0.2-0.4-0.5-0.3-0.8l1.6-8.3c0.7-3.8-1.4-7.6-5-8.9l-10.3-3.8c-0.9-0.3-1.8-0.5-2.8-0.5c-2.8,0-5.4,1.5-6.9,4l-4.1,7\n\tc-0.2,0.2-0.4,0.4-0.8,0.4c-2.7-0.2-5.5-0.1-8.2,0.2c-0.3,0-0.7-0.1-0.9-0.3l-4.7-6.9c-1.5-2.2-3.9-3.5-6.5-3.5\n\tc-1.1,0-2.3,0.2-3.3,0.7l-9.9,4.5c-3.5,1.6-5.4,5.5-4.3,9.2l2.1,8c0.1,0.3,0,0.6-0.3,0.8C64.6,65,62.7,67,61.1,69.1z M66.9,73.7\n\tc1.4-1.8,2.9-3.5,4.6-5c2.3-2.1,3.2-5.2,2.5-8.2l-2.1-8c-0.1-0.2,0-0.5,0.2-0.6l9.9-4.5c0.1,0,0.1,0,0.2,0c0.1,0,0.3,0,0.4,0.2\n\tl4.7,6.9c1.7,2.5,4.7,3.9,7.9,3.6c2.3-0.3,4.6-0.4,6.9-0.2c3.2,0.2,6.1-1.4,7.7-4.1l4.1-7c0.1-0.2,0.4-0.3,0.7-0.2l10.3,3.8\n\tc0.2,0.1,0.4,0.4,0.3,0.6l-1.6,8.3c-0.6,3,0.6,6.1,3,8c1.7,1.4,3.4,2.9,4.9,4.6c1.6,1.8,3.8,2.7,6.1,2.7c0.7,0,1.5-0.1,2.2-0.3\n\tl7.8-2.2c0.2,0,0.5,0,0.6,0.2l4.5,9.9c0.1,0.2,0,0.5-0.2,0.6l-7,4.7c-2.5,1.7-3.9,4.7-3.6,7.8c0.2,2.3,0.3,4.5,0.2,6.8\n\tc-0.2,3.1,1.4,6.1,4.1,7.6l7.1,4.1c0.2,0.1,0.3,0.4,0.2,0.7l-3.8,10.3c-0.1,0.2-0.4,0.4-0.6,0.3l-8.3-1.6c-0.5-0.1-1-0.2-1.5-0.2\n\tc-2.5,0-4.9,1.1-6.5,3.2c-1.4,1.7-2.9,3.4-4.6,4.9c-2.3,2.1-3.3,5.3-2.5,8.3l2.1,7.9c0.1,0.2,0,0.5-0.2,0.6l-9.9,4.5\n\tc-0.1,0-0.1,0-0.2,0c-0.1,0-0.3,0-0.4-0.2l-4.7-7c-1.7-2.5-4.7-3.9-7.8-3.6c-2.1,0.2-4.3,0.3-6.4,0.2c-3.1-0.1-6,1.5-7.6,4.1\n\tl-4.1,7.2c-0.1,0.2-0.4,0.3-0.7,0.2l-10.3-3.8c-0.2-0.1-0.4-0.4-0.3-0.6l1.6-8.1c0.6-3-0.6-6.1-3-8.1c-1.8-1.4-3.4-2.9-5-4.6\n\tc-1.6-1.7-3.8-2.7-6.1-2.7c-0.7,0-1.4,0.1-2.1,0.3l-8,2.1c-0.2,0-0.5,0-0.6-0.2l-4.5-9.9c-0.1-0.2,0-0.5,0.2-0.6l6.9-4.7\n\tc2.5-1.7,3.9-4.7,3.6-7.8c-0.2-2.2-0.3-4.5-0.2-6.8c0.1-3.1-1.4-6-4.1-7.5l-7.2-4.1c-0.2-0.1-0.3-0.4-0.2-0.7l3.8-10.2\n\tc0.1-0.2,0.4-0.4,0.6-0.4h0l8.1,1.6c0.5,0.1,1,0.2,1.6,0.2C62.9,76.8,65.3,75.7,66.9,73.7L66.9,73.7z"}},{"$":{"fill":"#000001","d":"M92,122.2c2.6,0.9,5.2,1.4,7.9,1.4c10,0,19-6.3,22.4-15.8c4.4-12.3-2.1-25.9-14.4-30.3\n\tc-2.6-0.9-5.2-1.4-7.9-1.4c-10,0-19,6.3-22.4,15.8C73.2,104.3,79.7,117.9,92,122.2L92,122.2z M84.6,94.4c2.3-6.5,8.5-10.8,15.4-10.8\n\tc1.8,0,3.7,0.3,5.5,0.9c8.5,3,12.9,12.4,9.9,20.8c-2.3,6.5-8.5,10.8-15.4,10.8c-1.8,0-3.7-0.3-5.5-0.9\n\tC86,112.3,81.6,102.9,84.6,94.4L84.6,94.4z"}}]}}

/***/ },
/* 12 */
/***/ function(module, exports) {

	module.exports = {"svg":{"$":{"version":"1.1","id":"图层_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 200 200","enable-background":"new 0 0 200 200","xml:space":"preserve"},"path":[{"$":{"d":"M169,94.7h-11.2c-1.8-8.9-5.3-17.2-10.2-24.4l7.9-7.9c2.8-2.8,2.8-7.5,0-10.3l-8.6-8.6c-2.8-2.8-7.5-2.8-10.3,0l-7.9,7.9\n\tc-7.4-4.9-15.6-8.4-24.4-10.2V30c0-4.1-3.3-7.2-7.2-7.2H84.8c-4.1,0-7.2,3.3-7.2,7.2v11.2c-8.9,1.8-17.2,5.3-24.4,10.2l-7.9-7.9\n\tc-2.8-2.8-7.5-2.8-10.3,0L26.4,52c-2.8,2.8-2.8,7.5,0,10.3l7.9,7.9c-4.9,7.4-8.4,15.6-10.2,24.4H12.9c-4.1,0-7.2,3.3-7.2,7.2V114\n\tc0,4.1,3.3,7.2,7.2,7.2h11.2c1.8,8.9,5.3,17.2,10.2,24.4l-7.9,7.9c-2.8,2.8-2.8,7.5,0,10.3l8.7,8.6c2.8,2.8,7.5,2.8,10.3,0l7.9-7.9\n\tc7.4,4.9,15.6,8.4,24.4,10.2v11.2c0,4.1,3.3,7.2,7.2,7.2h12.2c4.1,0,7.2-3.3,7.2-7.2v-11.2c8.9-1.8,17.2-5.3,24.4-10.2l7.9,7.9\n\tc2.8,2.8,7.5,2.8,10.3,0l8.6-8.6c2.8-2.8,2.8-7.5,0-10.3l-7.9-7.9c4.9-7.4,8.4-15.6,10.2-24.4h11.2c4.1,0,7.2-3.3,7.2-7.2v-12.2\n\tC176.2,98,173,94.7,169,94.7L169,94.7z M91,138.9c-17.1,0-30.9-13.8-30.9-30.9S74,77.1,91,77.1s30.9,13.8,30.9,30.9\n\tS108,138.9,91,138.9z"}},{"$":{"fill":"#111111","d":"M90.9,140.8c18.1,0,32.8-14.7,32.8-32.8S109,75.2,90.9,75.2S58.1,89.9,58.1,108S72.8,140.8,90.9,140.8z\n\t M90.9,85.5c12.4,0,22.6,10.1,22.6,22.6c0,12.6-10.1,22.6-22.6,22.6s-22.6-10.1-22.6-22.6S78.5,85.5,90.9,85.5z"}},{"$":{"fill":"#111111","d":"M196.2,53.1l-3.9-1.6c0.6-3.8,0.6-7.7,0-11.5l3.9-1.6c3.1-1.3,4.6-4.9,3.3-8l-2.5-6c-1.3-3.1-4.9-4.6-8-3.3\n\tl-3.9,1.6c-2.3-3.1-5-5.8-8.1-8.1l1.6-3.9c0.6-1.5,0.6-3.2,0-4.7c-0.6-1.5-1.8-2.7-3.3-3.3l-6-2.5c-3.1-1.3-6.7,0.2-8,3.3l-1.6,3.9\n\tc-3.8-0.6-7.7-0.6-11.5,0l-1.6-3.9c-1-2.4-3.3-3.8-5.7-3.8c-0.8,0-1.6,0.1-2.3,0.5l-6,2.5c-3.1,1.3-4.6,4.9-3.3,8l1.6,3.9\n\tc-3.1,2.3-5.8,5-8.1,8.1l-3.9-1.6c-3.1-1.3-6.7,0.2-8,3.3l-1.2,3c-1.5-5.4-6.5-9.5-12.5-9.5H84.8c-7.1,0-13,5.8-13,13v6.8\n\tc-6.3,1.7-12.3,4.2-18,7.5l-4.6-4.6c-2.5-2.5-5.8-3.7-9.2-3.7c-3.5,0-6.8,1.4-9.2,3.7l-8.6,8.6c-5.1,5.1-5.1,13.2,0,18.3l4.8,4.8\n\tc-3.3,5.7-5.8,11.6-7.5,18H13c-7.1,0-13,5.8-13,12.9v12.1c0,7.1,5.8,13,13,13h6.6c1.7,6.3,4.2,12.3,7.5,18l-4.8,4.8\n\tc-5.1,5.1-5.1,13.2,0,18.3l8.6,8.6c2.5,2.5,5.8,3.7,9.2,3.7c3.5,0,6.8-1.4,9.2-3.7l4.8-4.8c5.7,3.3,11.6,5.8,18,7.5v6.7\n\tc0,7.1,5.8,13,13,13h12.2c7.1,0,13-5.8,13-13v-6.7c6.3-1.7,12.3-4.2,18-7.5l4.8,4.8c2.5,2.5,5.8,3.7,9.2,3.7c3.5,0,6.8-1.4,9.2-3.7\n\tl8.6-8.6c5.1-5.1,5.1-13.2,0-18.3l-4.8-4.8c3.3-5.7,5.8-11.6,7.5-18h6.7c7.1,0,13-5.8,13-13v-12.2c0-6.2-4.4-11.5-10.3-12.7l3.4-1.4\n\tc1.5-0.6,2.7-1.8,3.3-3.3c0.6-1.5,0.6-3.2,0-4.7l-1.6-3.9c3.1-2.3,5.8-5,8.1-8.1l3.9,1.6c1.5,0.6,3.2,0.6,4.7,0\n\tc1.5-0.6,2.7-1.8,3.3-3.3l2.5-6c0.6-1.5,0.6-3.2,0-4.7C198.9,54.9,197.7,53.7,196.2,53.1z M110.2,37.5c0.1,0.1,0.1,0.1,0.2,0.2\n\tc-0.1,0-0.1,0-0.2-0.1V37.5z M170.3,115.3c0,0.8-0.7,1.5-1.5,1.5h-11.2c-2.7,0-5.1,1.9-5.7,4.6c-1.6,8-4.8,15.6-9.3,22.5\n\tc-1.5,2.3-1.2,5.3,0.7,7.1l7.9,7.9c0.3,0.3,0.5,0.8,0.5,1c0,0.3-0.1,0.7-0.5,1l-8.6,8.7c-0.3,0.3-0.8,0.5-1,0.5\n\tc-0.3,0-0.7-0.1-1-0.5l-7.9-7.9c-1.9-1.9-5-2.1-7.1-0.7c-6.9,4.6-14.4,7.7-22.5,9.3c-2.6,0.5-4.6,2.9-4.6,5.7v11.1\n\tc0,0.8-0.7,1.5-1.5,1.5H84.9c-0.8,0-1.5-0.7-1.5-1.5v-11.2c0-2.7-1.9-5.1-4.6-5.7c-8-1.6-15.6-4.8-22.5-9.3\n\tc-2.3-1.5-5.3-1.2-7.1,0.7l-7.9,7.9c-0.3,0.3-0.8,0.5-1,0.5c-0.3,0-0.7-0.1-1-0.5l-8.6-8.6c-0.7-0.7-0.7-1.6,0-2.1l7.9-7.9\n\tc1.9-1.9,2.1-5,0.7-7.1c-4.6-6.9-7.7-14.4-9.3-22.5c-0.5-2.6-2.9-4.6-5.7-4.6H13.1c-0.8,0-1.5-0.7-1.5-1.5v-12.2\n\tc0-0.8,0.7-1.5,1.5-1.5h11.2c2.6,0,4.9-1.8,5.4-4.5c1.6-8,4.8-15.6,9.3-22.5c1.5-2.3,1.2-5.3-0.7-7.1l-7.9-7.9\n\tc-0.7-0.7-0.7-1.6,0-2.1l8.6-8.6c0.3-0.3,0.8-0.5,1-0.5c0.3,0,0.7,0.1,1,0.5l7.9,7.9c1.9,1.9,5,2.1,7.1,0.7\n\tc6.9-4.6,14.4-7.7,22.5-9.3c2.6-0.5,4.6-2.9,4.6-5.7V31.1c0-0.8,0.7-1.5,1.5-1.5h12.2c0.8,0,1.5,0.7,1.5,1.5v11.2\n\tc0,2.7,1.9,5.1,4.6,5.7c8,1.6,15.6,4.8,22.5,9.3c0.9,0.7,2,0.9,3.2,0.9c1.5,0,2.9-0.6,4.1-1.7l7.9-7.9c0.3-0.3,0.8-0.5,1-0.5\n\tc0.3,0,0.7,0.1,1,0.5l8.6,8.6c0.7,0.7,0.7,1.6,0,2.1l-7.9,7.9c-1.9,1.9-2.1,5-0.7,7.1c4.6,6.9,7.7,14.4,9.3,22.5\n\tc0.5,2.6,2.9,4.6,5.7,4.6h11.2c0.8,0,1.5,0.7,1.5,1.5V115.3z M159.8,48.9l-8.6-8.6c-1.6-1.6-3.5-2.7-5.6-3.2\n\tc2.2-2.1,5.1-3.3,8.2-3.3h0.1c3.2,0,6.2,1.2,8.4,3.4c2.3,2.3,3.6,5.2,3.6,8.5c0,3-1.1,5.8-3,8C162.2,52,161.2,50.3,159.8,48.9z\n\t M162.5,89.8C162.5,89.9,162.6,89.9,162.5,89.8L162.5,89.8C162.5,89.9,162.5,89.9,162.5,89.8z M195.5,59.3l-2.5,6\n\tc-0.2,0.4-0.5,0.7-0.9,0.9c-0.4,0.2-0.9,0.2-1.3,0l-5.6-2.3c-1-0.4-2.1-0.1-2.7,0.8c-2.5,3.8-5.7,7-9.5,9.5\n\tc-0.9,0.6-1.2,1.7-0.8,2.7l2.3,5.6c0.2,0.4,0.2,0.9,0,1.3c-0.2,0.4-0.5,0.7-0.9,0.9l-6,2.5c-0.8,0.3-1.8,0-2.2-0.9l-2.3-5.6\n\tc-0.5-1.1-1.8-1.7-2.9-1.2c-0.4,0.2-0.7,0.5-1,0.8c-1.2-2.9-2.6-5.7-4.2-8.4l4.8-4.8c2.6-2.6,3.8-5.9,3.8-9.3c0.5-0.4,1-0.8,1.4-1.3\n\tc2.9-3,4.5-6.9,4.4-11c-0.1-4.2-1.7-8.1-4.6-11c-3-2.9-6.8-4.4-10.9-4.4h-0.1c-4.2,0.1-8.1,1.7-11,4.6c-0.5,0.5-1,1.1-1.4,1.7\n\tc-3.3,0.2-6.3,1.5-8.5,3.7l-4.8,4.8c-2.9-1.7-5.9-3.2-9-4.4c0.4-0.2,0.8-0.6,1-1.1c0.5-1.1-0.1-2.4-1.2-2.9l-5.6-2.3\n\tc-0.4-0.2-0.7-0.5-0.9-0.9c-0.2-0.4-0.2-0.9,0-1.3l2.3-6.2c0.3-0.9,1.3-1.3,2.2-0.9l5.6,2.3c1,0.4,2.1,0.1,2.7-0.8\n\tc2.5-3.8,5.7-7,9.5-9.5c0.9-0.6,1.2-1.7,0.8-2.7l-2.3-5.6c-0.3-0.8,0-1.8,0.9-2.2l6-2.5c0.8-0.3,1.8,0,2.2,0.9l2.3,5.6\n\tc0.4,1,1.5,1.5,2.5,1.3c4.4-0.9,8.9-0.9,13.4,0c1,0.2,2.1-0.3,2.5-1.3l2.3-5.6c0.3-0.8,1.3-1.3,2.2-0.9l6,2.5\n\tc0.4,0.2,0.7,0.5,0.9,0.9c0.2,0.4,0.2,0.9,0,1.3l-2.3,5.6c-0.4,1-0.1,2.1,0.8,2.7c3.8,2.5,7,5.7,9.5,9.5c0.6,0.9,1.7,1.2,2.7,0.8\n\tl5.6-2.3c0.9-0.3,1.8,0,2.2,0.9l2.5,6c0.3,0.8,0,1.8-0.9,2.2l-5.6,2.3c-1,0.4-1.5,1.5-1.3,2.5c0.9,4.4,0.9,8.9,0,13.4\n\tc-0.2,1,0.3,2.1,1.3,2.5l5.6,2.3c0.4,0.2,0.7,0.5,0.9,0.9C195.7,58.4,195.7,58.9,195.5,59.3z"}},{"$":{"d":"M195.5,59.3l-2.5,6c-0.2,0.4-0.5,0.7-0.9,0.9c-0.4,0.2-0.9,0.2-1.3,0l-5.6-2.3c-1-0.4-2.1-0.1-2.7,0.8\n\tc-2.5,3.8-5.7,7-9.5,9.5c-0.9,0.6-1.2,1.7-0.8,2.7l2.3,5.6c0.2,0.4,0.2,0.9,0,1.3c-0.2,0.4-0.5,0.7-0.9,0.9l-6,2.5\n\tc-0.8,0.3-1.8,0-2.2-0.9l-2.3-5.6c-0.5-1.1-1.8-1.7-2.9-1.2c-0.4,0.2-0.7,0.5-1,0.8c-1.2-2.9-2.6-5.7-4.2-8.4l4.8-4.8\n\tc2.6-2.6,3.8-5.9,3.8-9.3c0.5-0.4,1-0.8,1.4-1.3c2.9-3,4.5-6.9,4.4-11c-0.1-4.2-1.7-8.1-4.6-11c-3-2.9-6.8-4.4-10.9-4.4h-0.1\n\tc-4.2,0.1-8.1,1.7-11,4.6c-0.5,0.5-1,1.1-1.4,1.7c-3.3,0.2-6.3,1.5-8.5,3.7l-4.8,4.8c-2.9-1.7-5.9-3.2-9-4.4c0.4-0.2,0.8-0.6,1-1.1\n\tc0.5-1.1-0.1-2.4-1.2-2.9l-5.6-2.3c-0.4-0.2-0.7-0.5-0.9-0.9c-0.2-0.4-0.2-0.9,0-1.3l2.3-6.2c0.3-0.9,1.3-1.3,2.2-0.9l5.6,2.3\n\tc1,0.4,2.1,0.1,2.7-0.8c2.5-3.8,5.7-7,9.5-9.5c0.9-0.6,1.2-1.7,0.8-2.7l-2.3-5.6c-0.3-0.8,0-1.8,0.9-2.2l6-2.5\n\tc0.8-0.3,1.8,0,2.2,0.9l2.3,5.6c0.4,1,1.5,1.5,2.5,1.3c4.4-0.9,8.9-0.9,13.4,0c1,0.2,2.1-0.3,2.5-1.3l2.3-5.6\n\tc0.3-0.8,1.3-1.3,2.2-0.9l6,2.5c0.4,0.2,0.7,0.5,0.9,0.9c0.2,0.4,0.2,0.9,0,1.3l-2.3,5.6c-0.4,1-0.1,2.1,0.8,2.7\n\tc3.8,2.5,7,5.7,9.5,9.5c0.6,0.9,1.7,1.2,2.7,0.8l5.6-2.3c0.9-0.3,1.8,0,2.2,0.9l2.5,6c0.3,0.8,0,1.8-0.9,2.2l-5.6,2.3\n\tc-1,0.4-1.5,1.5-1.3,2.5c0.9,4.4,0.9,8.9,0,13.4c-0.2,1,0.3,2.1,1.3,2.5l5.6,2.3c0.4,0.2,0.7,0.5,0.9,0.9\n\tC195.7,58.4,195.7,58.9,195.5,59.3z"}}]}}

/***/ },
/* 13 */
/***/ function(module, exports) {

	module.exports = {"svg":{"$":{"version":"1.1","id":"图层_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 200.8 200","enable-background":"new 0 0 200.8 200","xml:space":"preserve"},"path":[{"$":{"fill":"#FFC445","d":"M50.4,99.6c0,27.6,22.4,50,50,50s50-22.4,50-50s-22.4-50-50-50S50.4,72,50.4,99.6z"}},{"$":{"fill":"#FFC445","d":"M100.4,33.3c-3.8,0-6.2-2.9-6.2-6.3V5.8c0-3.3,2.5-5.8,5.8-5.8h0.4c3.3,0,6.2,2.9,6.2,6.2v21.2\n\tC106.7,30.4,103.8,33.3,100.4,33.3z M100.4,200c-3.8,0-6.2-2.9-6.2-6.2v-21.2c0-3.3,2.9-6.2,6.2-6.2h0.4c3.3,0,6.2,2.9,6.2,6.2v21.2\n\tC106.7,197.1,103.8,200,100.4,200z M166.7,99.6c0-3.8,2.9-6.2,6.2-6.2h21.2c3.3,0,6.2,2.9,6.2,6.2v0.4c0,3.3-2.9,6.2-6.2,6.2h-21.2\n\tC169.6,105.8,166.7,102.9,166.7,99.6z M0,99.6c0-3.8,2.9-6.2,6.2-6.2h21.2c3.3,0,6.2,2.9,6.2,6.2v0.4c0,3.3-2.9,6.2-6.2,6.2H6.2\n\tC2.9,105.8,0,102.9,0,99.6z M145,48.3c-2.5-2.5-2.5-6.2-0.4-8.8l15-15c2.5-2.5,6.2-2.5,8.8,0V25c2.5,2.5,2.5,6.2,0,8.8l-15,15\n\tC151.2,50.8,147.1,50.8,145,48.3L145,48.3z M27.1,166.2c-2.5-2.5-2.5-6.7-0.4-8.8l15-15c2.5-2.5,6.2-2.5,8.8,0l0.4,0.4\n\tc2.5,2.5,2.5,6.2,0,8.7l-15,15C33.3,168.8,29.6,168.8,27.1,166.2L27.1,166.2z M144.6,142.1c2.5-2.5,6.7-2.5,8.8-0.4l15,15\n\tc2.5,2.5,2.5,6.2,0,8.8l-0.4,0.4c-2.5,2.5-6.2,2.5-8.8,0l-15-15C142.1,148.3,142.1,144.6,144.6,142.1z M26.7,24.2\n\tc2.5-2.5,6.7-2.5,8.8-0.4l15,15c2.5,2.5,2.5,6.2,0,8.8L50,47.9c-2.5,2.5-6.2,2.5-8.8,0l-14.6-15C24.6,30.4,24.6,26.7,26.7,24.2z"}}]}}

/***/ },
/* 14 */
/***/ function(module, exports) {

	module.exports = {"svg":{"$":{"version":"1.1","id":"图层_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 200 200","enable-background":"new 0 0 200 200","xml:space":"preserve"},"path":[{"$":{"fill":"#424242","d":"M100,16.7c-22.9,0-41.7,18.8-41.7,41.7V75H75V58.3c0-13.8,11.2-25,25-25s25,11.2,25,25h16.7\n\tC141.7,35.4,122.9,16.7,100,16.7z"}},{"$":{"fill":"#FB8C00","d":"M150,183.3H50c-9.2,0-16.7-7.5-16.7-16.7v-75C33.3,82.5,40.8,75,50,75h100c9.2,0,16.7,7.5,16.7,16.7v75\n\tC166.7,175.8,159.2,183.3,150,183.3z"}},{"$":{"fill":"#C76E00","d":"M87.5,129.2c0,6.9,5.6,12.5,12.5,12.5s12.5-5.6,12.5-12.5c0-6.9-5.6-12.5-12.5-12.5S87.5,122.3,87.5,129.2z"}},{"$":{"d":"M125,58.3h16.7V75H125V58.3z"}}]}}

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(4)
	
	/* script */
	__vue_exports__ = __webpack_require__(21)
	
	/* template */
	var __vue_template__ = __webpack_require__(17)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(5)
	
	/* script */
	__vue_exports__ = __webpack_require__(22)
	
	/* template */
	var __vue_template__ = __webpack_require__(18)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 17 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('svg', {
	    class: _vm.clazz,
	    style: (_vm.style),
	    attrs: {
	      "version": "1.1",
	      "role": _vm.label ? 'img' : 'presentation',
	      "aria-label": _vm.label,
	      "width": _vm.width,
	      "height": _vm.height,
	      "viewBox": _vm.box
	    }
	  }, _vm._l((_vm.icon.paths), function(path) {
	    return _c('path', {
	      attrs: {
	        "d": path.d,
	        "fill": path.fill
	      }
	    })
	  }))
	},staticRenderFns: []}

/***/ },
/* 18 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('h3', [_vm._v("a simple solution for multicolor svg icon in Vue2.0")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "svg-icon-logo"
	    }
	  }, [_c('icon', {
	    attrs: {
	      "name": "chameleon",
	      "scale": 35
	    }
	  })]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "container"
	    }
	  }, [_c('section', [_c('h4', [_vm._v("simple usage")]), _vm._v(" "), _c('span', [_c('icon', {
	    staticStyle: {
	      "color": "#05CE7C"
	    },
	    attrs: {
	      "name": "chameleon",
	      "scale": "20"
	    }
	  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("spin")]), _vm._v(" "), _c('span', [_c('icon', {
	    attrs: {
	      "name": "sun",
	      "scale": "20",
	      "spin": ""
	    }
	  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("hover to change")]), _vm._v(" "), _c('span', [_c('icon', {
	    attrs: {
	      "name": "settings",
	      "scale": "20",
	      "id": "hover"
	    }
	  })]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("click to change")]), _vm._v(" "), _c('span', [_c('icon', {
	    attrs: {
	      "name": "unlock",
	      "scale": "20",
	      "id": "click"
	    }
	  })]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("animation")]), _vm._v(" "), _c('span', [_c('icon', {
	    attrs: {
	      "name": "chameleon",
	      "scale": "20",
	      "id": "animation"
	    }
	  })]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('section', [_c('h4', [_vm._v("advanced usage (tabbar)")]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "advanced"
	    }
	  }, [_c('div', [_c('div', [_c('icon', {
	    attrs: {
	      "name": "roboAd",
	      "scale": "12",
	      "index": "0",
	      "currentIndex": _vm.current
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.switchTo(0)
	      }
	    }
	  }), _vm._v(" "), _c('div', [_vm._v("btn1")])]), _vm._v(" "), _c('div', [_c('icon', {
	    attrs: {
	      "name": "pie",
	      "scale": "12",
	      "index": "1",
	      "currentIndex": _vm.current
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.switchTo(1)
	      }
	    }
	  }), _vm._v(" "), _c('div', [_vm._v("btn2")])]), _vm._v(" "), _c('div', [_c('icon', {
	    attrs: {
	      "name": "cup",
	      "scale": "12",
	      "index": "2",
	      "currentIndex": _vm.current
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.switchTo(2)
	      }
	    }
	  }), _vm._v(" "), _c('div', [_vm._v("btn3")])]), _vm._v(" "), _c('div', [_c('icon', {
	    attrs: {
	      "name": "settings2",
	      "scale": "12",
	      "index": "3",
	      "currentIndex": _vm.current
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.switchTo(3)
	      }
	    }
	  }), _vm._v(" "), _c('div', [_vm._v("btn4")])])])]), _vm._v(" "), _vm._m(5)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('code', [_c('pre', [_c('strong', [_vm._v("html:")]), _vm._v("\n<icon "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("name")]), _vm._v("="), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("\"chameleon\"")]), _vm._v(" "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("scale")]), _vm._v("="), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("\"20\"")]), _vm._v(" "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("style")]), _vm._v("="), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("\"color: #05CE7C;\"")]), _vm._v("></icon>")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('code', [_c('pre', [_c('strong', [_vm._v("html:")]), _vm._v("\n<icon "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("name")]), _vm._v("="), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("\"sun\"")]), _vm._v(" "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("scale")]), _vm._v("="), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("\"20\"")]), _vm._v(" "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("spin")]), _vm._v("></icon>")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('code', [_c('pre', [_c('strong', [_vm._v("html:")]), _vm._v("\n<icon "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("name")]), _vm._v("="), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("\"settings\"")]), _vm._v(" "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("scale")]), _vm._v("="), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("\"20\"")]), _vm._v(" "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("id")]), _vm._v("="), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("\"hover\"")]), _vm._v("></icon>\n"), _c('strong', [_vm._v("css3:")]), _vm._v("\n#hover:hover {\n    "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("color")]), _vm._v(":"), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("gold")]), _vm._v("\n}")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('code', [_c('pre', [_c('strong', [_vm._v("html:")]), _vm._v("\n<icon "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("name")]), _vm._v("="), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("\"unlock\"")]), _vm._v(" "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("scale")]), _vm._v("=\"20\" "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("id")]), _vm._v("="), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("\"click\"")]), _vm._v("></icon>\n"), _c('strong', [_vm._v("css3:")]), _vm._v("\n#click:active {\n    "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("color")]), _vm._v(":"), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("white")]), _vm._v("\n}")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('code', [_c('pre', [_c('strong', [_vm._v("html:")]), _vm._v("\n<icon "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("name")]), _vm._v("="), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("\"chameleon\"")]), _vm._v(" "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("scale")]), _vm._v("="), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("\"20\"")]), _vm._v(" "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("id")]), _vm._v("="), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("\"animation\"")]), _vm._v("></icon>\n"), _c('strong', [_vm._v("css3:")]), _vm._v("\n#animation {\n  "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("animation")]), _vm._v(": "), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("changeColor 5s infinite step-end")]), _vm._v(";\n}\n@keyframes changeColor {\n  0% {\n      "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("color")]), _vm._v(": "), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("red")]), _vm._v(";\n  }\n  20% {\n      "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("color")]), _vm._v(": "), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("yellow")]), _vm._v(";\n  }\n  40% {\n      "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("color")]), _vm._v(": "), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("blue")]), _vm._v(";\n  }\n  60% {\n      "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("color")]), _vm._v(": "), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("green")]), _vm._v(";\n  }\n  80% {\n      "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("color")]), _vm._v(": "), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("purple")]), _vm._v(";\n  }\n  100% {\n      "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("color")]), _vm._v(": "), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("gold")]), _vm._v(";\n  }\n}")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('code', {
	    attrs: {
	      "id": "adCode"
	    }
	  }, [_c('pre', [_c('strong', [_vm._v("pseudocode:")]), _vm._v("\n"), _c('strong', [_vm._v("html:")]), _vm._v("\n<icon "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("name")]), _vm._v("="), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("\"roboAd\"")]), _vm._v(" "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("scale")]), _vm._v("="), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("\"12\"")]), _vm._v(" "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("index")]), _vm._v("="), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("\"0\"")]), _vm._v(" "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v(":currentIndex")]), _vm._v("="), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("\"current\"")]), _vm._v(" "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("@click.native")]), _vm._v("="), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("\"switchTo(0)\"")]), _vm._v("></icon>\n<div>btn1</div>\n"), _c('strong', [_vm._v("css:")]), _vm._v("\n.active {\n  "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("color")]), _vm._v(": "), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("gold")]), _vm._v(";\n}\nsvg {\n  "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("color")]), _vm._v(": "), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("#fff")]), _vm._v(";\n  "), _c('span', {
	    staticClass: "attr"
	  }, [_vm._v("padding")]), _vm._v(": "), _c('span', {
	    staticClass: "val"
	  }, [_vm._v("5px 0 2px")]), _vm._v(";\n}\n"), _c('strong', [_vm._v("js:")]), _vm._v("\ndata (){\n  return {\n    current: \"0\"\n  }\n},\nmethods: {\n  switchTo(index){\n    this.current = index.toString();\n  }\n}\n          ")])])
	}]}

/***/ },
/* 19 */,
/* 20 */,
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(1);
	
	var icons = {}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: {
	    name: {
	      type: String,
	      required: true,
	      validator: function validator(val) {
	        return val in icons;
	      }
	    },
	    scale: [Number, String],
	    spin: Boolean,
	    flip: {
	      validator: function validator(val) {
	        return val === 'horizontal' || val === 'vertical';
	      }
	    },
	    label: String,
	    index: String,
	    currentIndex: String
	  },
	  computed: {
	    normalizedScale: function normalizedScale() {
	      var scale = this.scale;
	      scale = typeof scale === 'undefined' ? 1 : Number(scale);
	      if (isNaN(scale) || scale <= 0) {
	        (0, _util.warn)('Invalid prop: prop "scale" should be a number over 0.', this);
	        return 1;
	      }
	      return scale;
	    },
	    clazz: function clazz() {
	      return {
	        'svg-icon': true,
	        spin: this.spin,
	        'flip-horizontal': this.flip === 'horizontal',
	        'flip-vertical': this.flip === 'vertical',
	        'active': this.index === this.currentIndex
	      };
	    },
	    icon: function icon() {
	      if (icons[this.name].paths && Array.isArray(icons[this.name].paths)) {
	        return icons[this.name];
	      } else {
	        icons[this.name].paths = [{ "d": icons[this.name].d }];
	        return icons[this.name];
	      }
	    },
	    box: function box() {
	      return '0 0 ' + this.icon.width + ' ' + this.icon.height;
	    },
	    width: function width() {
	      return this.icon.width / 112 * this.normalizedScale;
	    },
	    height: function height() {
	      return this.icon.height / 112 * this.normalizedScale;
	    },
	    style: function style() {
	      if (this.normalizedScale === 1) {
	        return false;
	      }
	      return {
	        fontSize: this.normalizedScale + 'em'
	      };
	    }
	  },
	  inject: function inject(svgFile) {
	    var xml = __webpack_require__(6)("./" + svgFile + '.svg');
	    icons[svgFile] = xml.svg.$;
	    var tmpView = xml.svg.$.viewBox.split(' ');
	    icons[svgFile].width = 200;
	    icons[svgFile].height = 200;
	    icons[svgFile].paths = [];
	    // deal with the illustrator generated svg
	    if (xml.svg.g && !xml.svg.path) xml.svg.path = xml.svg.g[0].path;
	    for (var i = 0, max = xml.svg.path.length; i < max; i++) {
	      icons[svgFile].paths.push(xml.svg.path[i].$);
	    }
	  },
	  icons: icons
	};

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(1);
	
	exports.default = {
	  name: 'app',
	  components: {},
	  data: function data() {
	    return {
	      current: "0"
	    };
	  },
	
	  methods: {
	    switchTo: function switchTo(index) {
	      this.current = index.toString();
	    }
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.fbe675461aa62374f885.js